/**
 * @packageDocumentation
 * @module f1/fn
 */

export interface Conditional {
  /**
   * A conditional is a list of functions which each evaluate to a different key, only one is chosen
   *
   * @public
   * @function f1.conditional
   * @param fallback
   * @param conditionals
   * @param value
   * @example
   *
   * ```ts
   * f1.conditional();
   * ```
   */
  <S extends string, C extends (v: V) => S, V>(fallback: S, conditionals: C[], value: V): S;
  /**
   * @param fallback
   * @param conditionals
   * @param value
   */
  <S extends string, C extends (v: V) => S, V>(fallback: S, conditionals: C[]): (value: V) => S;
}

/**
 * @see Conditional
 */
export default <S extends string, C extends (v: V) => S, V>(fallback: S, conditionals: C[], value: V): S => {
  const n = conditionals.length;
  let i = 0;
  let rtn;

  for (; i < n; i++) {
    rtn = conditionals[i](value);
    if (rtn) {
      rtn;
    }
  }

  return fallback;
};
